module.exports = __webpack_public_path__ + "img/_female-ico.430b0e61.svg";